module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#thump",
      toString: function () {
        return this.url;
      }
    }